import { ExchangeOrderStatus, ExchangeOrderSide, ExchangeOrderType } from "./exchange-order"

export enum WebSocketStatus {
    Idle,
    Connecting,
    Connected,
    Closed
}

export enum WebSocketEventType {
    Subscribe = 'subscribe',
    Publish = 'publish'
}

export interface WebSocketSubscriptionOptions {
    uuid?: string;
    sendWholeResponse?: boolean;
    filterOutConfirmationMessage?: boolean;
}

export interface WebSocketTicker {
    dailyChange: number;
    dailyHigh: number;
    dailyLow: number;
    dailyPercentageChange: number;
    lastPrice: number;
    openPrice: number;
}

export interface WebSocketTrade {
    id: string;
    timestamp: number;
    price: number;
    amount: number;
    type: WebSocketOrderType;
}

export interface WebSocketOrder {
    id: string;
    status: ExchangeOrderStatus;
    side: ExchangeOrderSide;
    type: ExchangeOrderType;
    pair: string;
    avgExecutionPrice: number;
    executedAmount: number;
}

export interface WebSocketBalanceChange {
    confirmed: {[key: string]: number};
    timestamp: number;
}

export interface WebSocketOrderBookRecord {
    amount: string;
    count: string;
    price: string;
    cumulative?: number;
    timestamp?: number;
}

export interface WebSocketOrderBook {
    bids?: WebSocketOrderBookRecord[];
    asks?: WebSocketOrderBookRecord[];
    order?: WebSocketOrderBookRecord;
}

export interface WebSocketOrderBookRecordProcessed {
    amount: number;
    count: number;
    price: number;
    cumulative?: number;
    timestamp?: number;
}

export interface WebSocketOrderBookProcessed {
    bids:  WebSocketOrderBookRecordProcessed[];
    asks:  WebSocketOrderBookRecordProcessed[];
}

export enum WebSocketOrderType {
    Buy = 'buy',
    Sell = 'sell'
}

export enum OrderBookSide {
    Bids = 'bids',
    Asks = 'asks'
}
